// /utils/analytics.js

import axios from 'axios';

// Log the visit with details
export async function logVisitor(loadTime) {
  //console.log('logVisitor called with loadTime:', loadTime);
  try {
    const response = await axios.post('/api/log-visitor', { loadTime }, {
      withCredentials: true,
    });
    //console.log('Response from /api/log-visitor:', response.data.message);
  } catch (error) {
    console.error('Error logging visit:', error.response ? error.response.data : error.message);
  }
}

// Log the page view with details
export async function logPageView(page, timeSpent) {
  try {
    const response = await axios.post('/api/log-page-view', { page, timeSpent }, {
      withCredentials: true,
    });
    //console.log(response.data.message);
  } catch (error) {
    console.error('Error logging page view:', error.response ? error.response.data : error.message);
  }
}
